const name = 'square';


const contents = `
<path d="M13 23h36v36H13z" />
`;


/** @type {import ('./types').Icon} */
const icon = {
  name,
  contents,
};

export default icon;
